import { RemovableRef, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { CurrencyCodeKey, HealthMode, ProfileTabsType } from '../types';
import { TURNSTILE_TTL } from '@/constants';

interface State {
  drawer: boolean | null;
  theme: RemovableRef<string>;
  currency: RemovableRef<CurrencyCodeKey>;
  walletDialog: boolean;
  addressBookMenu: boolean;
  portfolioTab: ProfileTabsType | null;
  healthMode: RemovableRef<string>;
  turnstileToken: RemovableRef<string | null>;
  turnstileCreatedAt: RemovableRef<number>;
  airdropCheckInput: RemovableRef<string>;
  minDisplayedValue: RemovableRef<number>;
  hideValues: boolean;
}

export const useAppStore = defineStore('app', {
  state: (): State => ({
    drawer: null,
    theme: useLocalStorage('pinia/app/theme', 'dark'),
    hideValues: false,
    currency: useLocalStorage<CurrencyCodeKey>('pinia/app/currency', 'USD'),
    walletDialog: false,
    addressBookMenu: false,
    portfolioTab: null,
    turnstileToken: useLocalStorage('pinia/app/turnstile/token', null),
    turnstileCreatedAt: useLocalStorage('pinia/app/turnstile/createdAt', 0),
    healthMode: useLocalStorage('pinia/app/healthMode', HealthMode.ratio),
    airdropCheckInput: useLocalStorage('pinia/app/airdropCheckInput', ''),
    minDisplayedValue: useLocalStorage('pinia/app/minDisplayedBalance', 0),
  }),
  getters: {
    isHuman(state) {
      return () => {
        return (
          state.turnstileToken !== null &&
          state.turnstileCreatedAt > Date.now() - TURNSTILE_TTL
        );
      };
    },
    isDark(state) {
      return state.theme === 'dark';
    },
  },
  actions: {
    toggleHideValues() {
      this.hideValues = !this.hideValues;
    },
    toogleTheme() {
      this.theme = this.isDark ? 'light' : 'dark';
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    toogleWalletDialog() {
      this.walletDialog = !this.walletDialog;
    },
    toogleAddressBookMenu() {
      this.addressBookMenu = !this.addressBookMenu;
    },
    toggleHealthMode() {
      if (this.healthMode === HealthMode.factor)
        this.healthMode = HealthMode.ratio;
      else this.healthMode = HealthMode.factor;
    },
    setTurnstileToken(token: string) {
      this.turnstileToken = token;
      this.turnstileCreatedAt = Date.now();
    },
  },
});
